<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <Sidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <Models v-if="!creating" @create="showCreate" @edit="editItem($event)" />
      <CreateModel v-else @cancel="cancelModel" :itemToEdit="itemToEdit" />
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import Sidebar from '@/components/Navigations/Sidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import { mapActions, mapGetters } from 'vuex';
import Models from '../../components/Admin/AiModels/Models.vue';
import CreateModel from '../../components/Admin/AiModels/CreateModel.vue';

export default {
  components: {
    Sidebar,
    TopNavbar,
    Models,
    CreateModel,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    creating: false,
    isToggled: false,
    itemToEdit: null,
  }),
  methods: {
    ...mapActions(['retrieveUserProfile']),

    cancelModel() {
      this.creating = false;
      this.itemToEdit = null;
    },
    showCreate() {
      this.creating = true;
    },

    editItem(item) {
      this.itemToEdit = item;
      this.creating = true;
    },

    cancelTitle() {
      this.creating = false;
      this.itemToEdit = null;
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    this.retrieveUserProfile();
  },
};
</script>
